import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { storageKey } from './storageKeys';

interface GuestState {
  guestToken?: string;
  /** Runtime identity fence; never persisted with the token. */
  sessionEpoch: number;
  saveGuestToken: (guestToken: string) => void;
  clear: () => void;
}

/**
 * 게스트 토큰 (30일). 진단·찜·AI 플래너를 비로그인으로 쓰고, 가입·로그인 시
 * X-Glow-Guest 헤더로 회원에게 병합한다 (실행계획 3.5).
 */
export const useGuestStore = create<GuestState>()(
  persist(
    (set) => ({
      guestToken: undefined,
      sessionEpoch: 0,
      saveGuestToken: (guestToken) =>
        set((state) => ({ guestToken, sessionEpoch: state.sessionEpoch + 1 })),
      clear: () =>
        set((state) => ({
          guestToken: undefined,
          sessionEpoch: state.sessionEpoch + 1,
        })),
    }),
    {
      name: storageKey.GUEST_STORE,
      partialize: ({ guestToken }) => ({ guestToken }),
    },
  ),
);
